import Stat from './Stat/Stat';

interface IStatsProps {
  stats: {type: string; value: number}[];
}

const Stats = ({stats}: IStatsProps) => {
  return (
    <>
      {stats.map(({type, value}) => (
        <Stat key={type} type={type} value={value} />
      ))}
    </>
  );
};

export default Stats;
